export * from './frequency-table.component';
export * from './frequency-table.model';
